export default __webpack_public_path__ + "static/media/survey-result.1e5768d6.svg";